import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "./components/Card";
import changecard from "./sounds/change_card.aac";
import match from "./sounds/match.aac";
import lastSeconds from "./sounds/last-seconds.mp3";
import winSound from "./sounds/win-sound.aac";
import loosSound from "./sounds/loos-sound.aac";
import logo from "./images/logo.png";
import startButton from "./images/start-button.png";
import restartButton from "./images/restart-button.png";
import frontFace from "./images/front-card-face.png";
import backFace from "./images/back-card-face.png";
import sadFace from "./images/sad-face.png";
import cup from "./images/cup.png";
import p1 from "./images/p1.jpg";
import p2 from "./images/p2.jpg";
import p3 from "./images/p3.jpg";
import p4 from "./images/p4.jpg";
import p5 from "./images/p5.jpg";
import p6 from "./images/p6.jpg";
import p7 from "./images/p7.jpg";
import p8 from "./images/p8.jpg";
import p9 from "./images/p9.jpg";
import p10 from "./images/p10.jpg";
import p11 from "./images/p11.jpg";
import p12 from "./images/p12.jpg";
import Countdown from "react-countdown";
import Confetti from "react-confetti";

// const tele = window.Telegram.WebApp;

function App() {
  const [products, setProducts] = useState([
    { id: 1, title: "1", image: p1 },
    { id: 2, title: "2", image: p2 },
    { id: 3, title: "3", image: p3 },
    { id: 4, title: "4", image: p4 },
    { id: 5, title: "5", image: p5 },
    { id: 6, title: "6", image: p6 },
    { id: 7, title: "7", image: p7 },
    { id: 8, title: "8", image: p8 },
    { id: 9, title: "9", image: p9 },
    { id: 10, title: "10", image: p10 },
    { id: 11, title: "11", image: p11 },
    { id: 12, title: "12", image: p12 },
  ]);
  const [cards, setCards] = useState([
    { id: 1, title: "1", image: p1 },
    { id: 2, title: "2", image: p2 },
    { id: 3, title: "3", image: p3 },
    { id: 4, title: "4", image: p4 },
    { id: 5, title: "5", image: p5 },
    { id: 6, title: "6", image: p6 },
    { id: 7, title: "7", image: p7 },
    { id: 8, title: "8", image: p8 },
    { id: 9, title: "9", image: p9 },
    { id: 10, title: "10", image: p10 },
    { id: 11, title: "11", image: p11 },
    { id: 12, title: "12", image: p12 },
  ]);

  const [gameStatus, setGameStatus] = useState("idle");
  const [totalSeconds, setTotalSeconds] = useState(Date.now() + 95000);
  const [win, setWin] = useState(false);
  const [giftSelected, setGiftSelected] = useState(false);
  const [giftList, setGiftList] = useState([]);
  const [lastSecondsAudio, setLastSecondsAudio] = useState(
    new Audio(lastSeconds)
  );

  // const lastSecondsAudio = ;

  const timer = useRef();
  const resultBox = useRef();
  const gameBox = useRef();

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    // tele.ready();
    // tele.expand();
    // console.log(tele.platform);
    if (cards.length > 12) return;
    let c = [...cards];
    for (let i = 0; i < 12; i++) {
      c.push({ id: 13 + i, title: c[i].title, image: c[i].image });
    }

    let suffle = shuffle(c);
    setCards(suffle);
    gameBox.current.classList.add("scale-in-center");
  }, []);

  const onGiftFrontClicked = (index, id) => {
    if (giftSelected) return;
    let c = JSON.parse(JSON.stringify(giftList));
    let i = 0;
    c.forEach((element) => {
      if (element.id === id && i === index) {
        element.flipped = true;
        let gifts = getCookie("gifts");
        gifts = gifts.split(",");
        let text = "";
        gifts.forEach((element1) => {
          let sp = element1.split("=");
          if (Number(sp[0]) === Number(element.id)) {
            sp[1] = Number(sp[1]) + 1;
            element1 = sp[0] + "=" + sp[1];
          }
          if (text === "") text = element1;
          else text += "," + element1;
        });

        setCookie("gifts", text, 365);
      }
      i++;
    });
    setGiftList(c);
    setGiftSelected(true);
    var audio = new Audio(winSound);
    audio.play();
  };

  const userWin = () => {
    timer.current.pause();
    lastSecondsAudio.pause();
    lastSecondsAudio.currentTime = 0;
    let gifts = getCookie("gifts");
    let final = [];

    if (!gifts) {
      let text = "";
      products.forEach((element) => {
        final.push(element);
        if (text === "") text = element.id + "=0";
        else text += "," + element.id + "=0";
      });
      setCookie("gifts", text, 365);
    } else {
      gifts = gifts.split(",");
      let g = [];
      gifts.forEach((element) => {
        let sp = element.split("=");
        if (Number(sp[1]) < 2) {
          products.forEach((element1) => {
            if (Number(element1.id) === Number(sp[0])) g.push(element1);
          });
        }
      });

      if (g.length > 0) {
        while (final.length < 12) {
          g.forEach((element) => {
            if (final.length < 12) final.push(element);
          });
        }
      } else {
        let text = "";
        products.forEach((element) => {
          final.push(element);
          if (text === "") text = element.id + "=0";
          else text += "," + element.id + "=0";
        });
        setCookie("gifts", text, 365);
      }
    }

    let suffle = shuffle(final);
    setGiftList(suffle);
    setWin(true);

    var audio = new Audio(winSound);
    audio.play();
    setTimeout(() => {
      setGameStatus("result");
      resultBox.current.classList.remove("slide-out-elliptic-top-bck");
      resultBox.current.classList.add("slide-in-elliptic-bottom-fwd");
      gameBox.current.classList.remove("scale-in-center");
      gameBox.current.classList.add("slide-out-bck-center");
    }, 1000);
  };

  const onFrontClicked = (index, id) => {
    if (gameStatus !== "playing") return;
    let c = [...cards];

    let totalFlipped = [];

    c.forEach((element) => {
      if (element.id === id) {
        element.flipped = true;
        totalFlipped.push(element.title);
      } else if (element.flipped && !element.matched && !element.waiting)
        totalFlipped.push(element.title);
    });
    setCards(c);

    var audio = new Audio(changecard);
    audio.play();
    if (totalFlipped.length === 2) {
      if (totalFlipped[0] === totalFlipped[1]) {
        let stillRemain = false;
        c.forEach((element) => {
          if (element.title === totalFlipped[0]) element.matched = true;
          if (!element.matched) stillRemain = true;
        });
        setCards(c);

        setTimeout(() => {
          var audio = new Audio(match);
          audio.play();
        }, 400);

        if (!stillRemain) {
          userWin();
        }
      } else {
        c.forEach((element) => {
          if (
            element.flipped &&
            !element.matched &&
            (element.title === totalFlipped[0] ||
              element.title === totalFlipped[1])
          )
            element.waiting = true;
        });

        setCards(c);

        setTimeout(() => {
          let cc = [...cards];
          cc.forEach((element) => {
            if (
              element.flipped &&
              !element.matched &&
              (element.title === totalFlipped[0] ||
                element.title === totalFlipped[1]) &&
              element.waiting
            ) {
              element.flipped = false;
              element.waiting = false;
            }
          });

          setCards(cc);
        }, 900);
      }
    }
  };

  function shuffle(array) {
    var m = array.length,
      t,
      i;
    while (m) {
      i = Math.floor(Math.random() * m--);
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }
    return array;
  }

  const onStartGame = () => {
    timer.current.start();
  };

  const onRestartGame = () => {
    let c = [...cards];

    c.forEach((element) => {
      element.flipped = false;
      element.waiting = false;
      element.matched = false;
    });

    let suffle = shuffle(c);
    setCards(suffle);

    c = JSON.parse(JSON.stringify(giftList));

    c.forEach((element) => {
      element.flipped = false;
    });
    setGiftList(c);

    resultBox.current.classList.remove("slide-in-elliptic-bottom-fwd");
    resultBox.current.classList.add("slide-out-elliptic-top-bck");
    gameBox.current.classList.remove("slide-out-bck-center");
    gameBox.current.classList.add("scale-in-center");

    setTimeout(() => {
      setGameStatus("idle");
      setTotalSeconds(Date.now() + 95000);
      setGiftSelected(false);
      // resultBox.current.classList.remove("slide-out-elliptic-top-bck");
    }, 700);
  };

  const onTimerComplete = () => {
    setWin(false);
    setGameStatus("result");
    resultBox.current.classList.remove("slide-out-elliptic-top-bck");
    resultBox.current.classList.add("slide-in-elliptic-bottom-fwd");
    gameBox.current.classList.remove("scale-in-center");
    gameBox.current.classList.add("slide-out-bck-center");
    var audio = new Audio(loosSound);
    audio.play();
    // setTimeout(() => {
    //   resultBox.current.classList.remove("slide-in-elliptic-bottom-fwd");
    // }, 1300);
  };

  return (
    <Container sx={{ minWidth: "100%" }}>
      <Grid
        container
        spacing={2}
        sx={{
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
        // className="scale-in-center"
        ref={gameBox}
      >
        <Grid item xs={1}></Grid>
        <Grid item xs={6.5}>
          <Box className="grid">
            {cards.map((item, i) => {
              return (
                <Card
                  key={i}
                  index={i}
                  onFrontClicked={onFrontClicked}
                  info={item}
                  flipped={item.flipped}
                  frontFace={frontFace}
                  backFace={backFace}
                  matched={item.matched}
                />
              );
            })}
          </Box>
        </Grid>
        <Grid item xs={0.5} />
        <Grid
          item
          xs={3}
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "16px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              border: "8px solid white",
              borderRadius: "20px",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              alignItems: "center",
            }}
          >
            <img
              src={logo}
              alt=""
              style={{
                width: "80%",
                objectFit: "contain",
                marginTop: "-90px",
              }}
            />
            <Box
              sx={{
                margin: "20px 30px",
                color: "white",
                fontSize: "40px",
                fontFamily: "BYekan",
                fontWeight: "bold",
              }}
            >
              زمان بازی
            </Box>
            <Box
              sx={{
                border: "8px solid white",
                minHeight: "100px",
                borderRadius: "20px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                textAlign: "center",
                fontSize: "40px",
                fontFamily: "Pixel",
                color: "#FF5252",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px 80px",
                marginBottom: "15px",
              }}
            >
              <Countdown
                date={totalSeconds}
                renderer={(props) => (
                  <div>
                    {props.minutes.toString().padStart(2, "0")}:
                    {props.seconds.toString().padStart(2, "0")}
                  </div>
                )}
                autoStart={false}
                ref={timer}
                onStart={() => {
                  setGameStatus("playing");
                  setTotalSeconds(Date.now() + 95000);

                  let c = [...cards];

                  c.forEach((element) => {
                    element.flipped = true;
                  });
                  setCards(c);
                  setTimeout(() => {
                    let c = [...cards];

                    c.forEach((element) => {
                      element.flipped = false;
                    });
                    setCards(c);
                  }, 5000);
                }}
                onTick={(e) => {
                  if (e.total === 10000) {
                    lastSecondsAudio.play();
                  }
                }}
                onComplete={onTimerComplete}
              />
            </Box>

            {gameStatus === "idle" && (
              <Box sx={{ width: "100%" }}>
                <img
                  className="vibrate-1"
                  src={startButton}
                  alt=""
                  style={{
                    width: "100%",
                    objectFit: "contain",
                    marginBottom: "-50px",
                    cursor: "pointer",
                  }}
                  onClick={onStartGame}
                />
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={1} />
      </Grid>

      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          left: "0",
          top: "0",
          display: "flex",
          visibility: gameStatus === "result" ? "visible" : "hidden",
        }}
      >
        {gameStatus === "result" && <Confetti />}
        <Box ref={resultBox} className="resultBox">
          <img
            src={logo}
            alt=""
            style={{
              width: "240px",
              objectFit: "contain",
              marginTop: "-90px",
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: win ? "row" : "column",
              justifyContent: win ? "space-between" : "center",
              alignItems: "center",
              width: "80%",
            }}
          >
            <img
              src={win ? cup : sadFace}
              alt=""
              style={{
                width: win ? "120px" : "35%",
                objectFit: "contain",
                marginTop: win ? "30px" : "60px",
                marginBottom: win ? "30px" : "0px",
              }}
            />

            <Box
              sx={{
                margin: win ? "20px 0px" : "40px 0px",
                color: "white",
                fontSize: "30px",
                fontFamily: "BYekan",
                whiteSpace: "wrap",
                textAlign: "center",
              }}
            >
              {!win ? "شانس باهات یار نبود" : "تبریک، برنده شدی"}
              {win && <br />}
              {win ? "یکی از کارت‌های زیر رو انتخاب کن" : ""}
            </Box>
            {win && (
              <img
                src={cup}
                alt=""
                style={{
                  width: "120px",
                  objectFit: "contain",
                  margin: "30px 0px",
                }}
              />
            )}
          </Box>

          {win && (
            <Box className="grid" style={{ width: "45vw", margin: "0px" }}>
              {giftList.map((item, i) => {
                return (
                  <Card
                    key={i}
                    index={i}
                    onFrontClicked={onGiftFrontClicked}
                    info={item}
                    flipped={item.flipped}
                    frontFace={frontFace}
                    backFace={backFace}
                  />
                );
              })}
            </Box>
          )}

          {(!win || (win && giftSelected)) && (
            <Box sx={{ width: "50%" }}>
              <img
                className="vibrate-1"
                src={restartButton}
                alt=""
                style={{
                  width: "100%",
                  objectFit: "contain",
                  marginTop: !win ? "0px" : "30px",
                  marginBottom: !win ? "-30px" : "-40px",
                  cursor: "pointer",
                }}
                onClick={onRestartGame}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  );
}

export default App;
